module.exports = __webpack_public_path__ + "img/eye.4b30758f.svg";